export const ADDRESS_ID_FOR_DELIVERY = 'addressIdDel';
export const ADDRESS_STATE_FOR_DELIVERY = 'addressStateForDelivery';
export const ADDRESS_CITY_FOR_DELIVERY = 'addressCityForDelivery';
